export default (a, b) => {
  return Date.parse(b.timestamp) - Date.parse(a.timestamp)
}
